import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CalendarRange } from "lucide-react";

const MONTH_ABBR = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function buildMonthlySeries(incomes, expenses) {
    const byMonth = {};

    const addTo = (item, field) => {
        const d = new Date(item.transacao_data);
        const key = `${d.getFullYear()}-${String(d.getMonth()).padStart(2, '0')}`;
        if (!byMonth[key]) {
            byMonth[key] = { key, year: d.getFullYear(), month: d.getMonth(), Receitas: 0, Gastos: 0 };
        }
        byMonth[key][field] += item.transacao_valor;
    };

    (incomes || []).forEach((i) => addTo(i, 'Receitas'));
    (expenses || []).forEach((e) => addTo(e, 'Gastos'));

    return Object.values(byMonth)
        .sort((a, b) => a.key.localeCompare(b.key))
        .map((m) => ({ ...m, label: `${MONTH_ABBR[m.month]}/${String(m.year).slice(-2)}` }));
}

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-card p-3" style={{ border: '1px solid var(--color-border)' }}>
                <p className="small mb-2">{label}</p>
                {payload.map((entry) => (
                    <p key={entry.dataKey} className="mb-0 small" style={{ color: entry.color }}>
                        {entry.name}: R${entry.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                ))}
            </div>
        );
    }
    return null;
};

export function ComparisonCard({ incomes, expenses }) {
    const data = buildMonthlySeries(incomes, expenses);
    const chartWidth = Math.max(600, data.length * 70);

    return (
        <div className="card custom-card h-100">
            <div className="card-body p-4">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <div className="icon-container">
                        <CalendarRange size={16} className="text-muted-custom" />
                    </div>
                    <div>
                        <h3 className="h5 fw-semibold mb-0">Comparativo ao Longo do Tempo</h3>
                        <p className="text-muted-custom small mb-0">Compare mês a mês, ano a ano, ou o mesmo mês em anos diferentes</p>
                    </div>
                </div>

                {data.length === 0 ? (
                    <p className="text-muted-custom small mb-0">Sem lançamentos suficientes para comparar ainda.</p>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <div style={{ width: `${chartWidth}px`, height: '320px' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={data}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
                                    <XAxis
                                        dataKey="label"
                                        stroke="var(--color-text-secondary)"
                                        tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
                                    />
                                    <YAxis
                                        stroke="var(--color-text-secondary)"
                                        tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
                                    />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend wrapperStyle={{ fontSize: 12, color: 'var(--color-text-secondary)' }} />
                                    <Bar dataKey="Receitas" fill="var(--color-primary)" radius={[6, 6, 0, 0]} />
                                    <Bar dataKey="Gastos" fill="var(--color-danger)" radius={[6, 6, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
